import React from 'react';
import cn from 'classnames';
import { useDroppable } from '@dnd-kit/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/pro-light-svg-icons';
import './AdminNavTrash.scss';

import { NAV_TRASH_ID } from '../../constants/admin_nav_constants';

// Drop zone shown below the bar only while dragging; the cursor (not the chip) lands here to remove.
const AdminNavTrash = () => {
  const { setNodeRef, isOver } = useDroppable({ id: NAV_TRASH_ID });

  return (
    <div ref={setNodeRef} className={cn('nav-trash', { over: isOver })}>
      <FontAwesomeIcon icon={faTrashAlt} />
      <span>{isOver ? 'Release to remove' : 'Drag here to remove'}</span>
    </div>
  );
};

export default AdminNavTrash;
